import { Icon, Menu } from "@mui/material";
import cx from "classnames";
import React from "react";
import { StyledMenuItem } from "src/components/StyledMenuItem/StyledMenuItem";
import "./Tabs.scss";

interface Tab {
  name: string;
  path: string;
}

interface TabsProps {
  pages: Tab[];
  pathname: string;
  isNew: boolean;
  id: string;
  basePath: string;
  setChangeToURL: (url: string) => void;
  pinnedTab?: string | null;
  setPinnedTab?: (value: string | null) => void;
}

export const Tabs = ({ pages, pathname, isNew, setChangeToURL, id, setPinnedTab, pinnedTab, basePath }: TabsProps) => {
  const [contextMenu, setContextMenu] = React.useState<{
    mouseX: number;
    mouseY: number;
    index: number;
  } | null>(null);

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
            index: parseInt((event.target as HTMLElement)?.dataset.index || "0", 10),
          }
        : null,
    );

    const selection = document.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      setTimeout(() => {
        selection.addRange(range);
      });
    }
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const handlePin = () => {
    setPinnedTab(pages[contextMenu?.index || 0]?.path);
    setContextMenu(null);
  };

  const handleUnpin = () => {
    setPinnedTab(null);
    setContextMenu(null);
  };

  return (
    <div className="nav-tabs">
      {pages.map((tab, index) => {
        const selected = pathname === tab.path;
        return (
          <button
            data-index={index}
            onContextMenu={handleContextMenu}
            key={index}
            disabled={isNew}
            className={cx({ active: selected })}
            onClick={e => {
              e.preventDefault();
              setChangeToURL(`/${basePath}/${id}/${tab.path}`);
            }}>
            {tab.name}
            {pinnedTab === tab.path && (
              <span>
                &nbsp;
                <Icon>push_pin</Icon>
              </span>
            )}
          </button>
        );
      })}

      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
        {pages[contextMenu?.index]?.path !== pinnedTab ? (
          <StyledMenuItem sx={{ fontSize: "14px" }} onClick={handlePin}>
            Pin Tab
          </StyledMenuItem>
        ) : (
          <StyledMenuItem sx={{ fontSize: "14px" }} onClick={handleUnpin}>
            Unpin Tab
          </StyledMenuItem>
        )}
      </Menu>
    </div>
  );
};
